import { render, staticRenderFns } from "./AttentionToolSet.vue?vue&type=template&id=3f5a5d9f&scoped=true&"
import script from "./AttentionToolSet.vue?vue&type=script&lang=js&"
export * from "./AttentionToolSet.vue?vue&type=script&lang=js&"
import style0 from "./AttentionToolSet.vue?vue&type=style&index=0&id=3f5a5d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a5d9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpeedDial,VTooltip})
